import { motion } from "framer-motion";

const ServiceCard = ({ icon: Icon, title, description, color, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.06, duration: 0.5 }}
      whileHover={{ y: -8, scale: 1.02 }}
      className="relative rounded-2xl p-7 group cursor-pointer transition-all duration-400 overflow-hidden"
      style={{
        background: "rgba(15, 22, 48, 0.85)",
        backdropFilter: "blur(20px)",
        border: "1px solid rgba(255, 255, 255, 0.08)",
        boxShadow: "0 4px 24px rgba(0, 0, 0, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.02)",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = `${color}40`;
        e.currentTarget.style.boxShadow = `0 12px 40px rgba(0, 0, 0, 0.35), 0 0 25px ${color}15, inset 0 1px 0 rgba(255, 255, 255, 0.04)`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.08)";
        e.currentTarget.style.boxShadow = "0 4px 24px rgba(0, 0, 0, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.02)";
      }}
    >
      {/* Top glowing bar on hover */}
      <div
        className="absolute top-0 left-0 right-0 h-[2px] opacity-0 group-hover:opacity-100 transition-all duration-700"
        style={{
          background: `linear-gradient(90deg, transparent, ${color}, transparent)`,
        }}
      />

      {/* Glow effect inside card */}
      <div
        className="absolute -right-16 -top-16 w-32 h-32 rounded-full opacity-0 group-hover:opacity-25 blur-3xl transition-opacity duration-500 pointer-events-none"
        style={{ background: color }}
      />

      {/* Icon Container */}
      <div
        className="icon-glow w-12 h-12 rounded-xl flex items-center justify-center mb-6 transition-all duration-400 group-hover:scale-110"
        style={{
          background: `${color}12`,
          border: `1px solid ${color}25`,
        }}
      >
        <Icon
          className="w-6 h-6"
          style={{
            color: color,
            filter: `drop-shadow(0 0 8px ${color}60)`,
          }}
        />
      </div>

      {/* Title */}
      <h3 className="text-lg font-bold text-white mb-3 group-hover:text-[#27B8FF] transition-colors duration-300">
        {title}
      </h3>

      {/* Description */}
      <p className="text-sm leading-relaxed text-[#A7B1D0]">
        {description}
      </p>
    </motion.div>
  );
};

export default ServiceCard;
